import { Injectable } from '@angular/core';
import {AuthService} from "./auth.service";
import {ApiService} from "./api.service";
import {ViewService} from "./view.service";
import {Subject} from "rxjs";
import {
  Organization
} from "../../classes/common/organization";
import {Poi, DEMO_POIS} from "../../classes/common/poi";
import {
  Platform,
  TypeParticipant
} from "../../classes/common/platform";
import {
  GeneralConfig
} from "../../classes/common/generalConfig";
import {
  Partecipant
} from "../../classes/common/partecipant";
import {
  DEMO_ROUTES,
  DEMO_ROUTES_LIVE
} from "../../classes/common/position-gps";
import {AlarmPoi} from "../../classes/common/alarm-poi";
import {Fleet} from "src/app/classes/common/fleet";
import {Storage} from "@ionic/storage";
import {Ticket} from "src/app/classes/common/ticket";
import {DeadlineTarget} from "src/app/classes/common/deadline";
import {Deadline} from "src/app/classes/common/deadline";
import {Utility} from "../../classes/common/utility";
import {TrackerGps} from "src/app/classes/common/tracker-gps";
import {AlertPopupService} from "./alert-popup.service";
import {ModalController} from "@ionic/angular";
import {AppLauncher} from "@capacitor/app-launcher";

@Injectable({
  providedIn: 'root'
})
export class DataService {

  static api: ApiService;
  static firebase: any;
  static initialized: boolean = false;
  static onInit = new Subject<any>();
  static onInit$ = DataService.onInit.asObservable();

  static hasGeneralConfig: boolean = false;
  static onGeneralConfig = new Subject<any>();
  static onGeneralConfig$ = DataService.onGeneralConfig.asObservable()

  static activationImei: string;
  static activationSerial: string;
  static activationModel: string;
  static registrationEmail: string;
  static customerPhone: string;
  static ownerPhone: string;

  showTabs: boolean = true;
  showDemoBadge: boolean = true;

  static limit: number = 5000;
  organizations: Organization[] = [];

  notificationsCount: number;
  ticketCount: number;

  public selOrganization: Organization = new Organization();
  static idOrganization: string;
  public pois: Poi[] = [];
  static platform: Platform = new Platform();

  static updateData = new Subject<any>();
  static updateData$ = DataService.updateData.asObservable();

  intervalsDemo: any[] = [];

  mobile_usersPage_user: any;
  mobile_ticketsPage_ticket: any;

  isDemo: boolean;
  static nativeApp: 'ios' | 'android' | undefined;
  static version: string;
  /** Timestamp (ms) dell'ultimo fetch riuscito di general_parameter. Usato per
   *  decidere se rifetchare al foreground (vedi refreshGeneralConfigIfStale). */
  static generalConfigFetchedAt: number = 0;
  /** Max età (ms) del general_parameter oltre la quale si rifetch al foreground. */
  static readonly GENERAL_CONFIG_MAX_AGE_MS = 24 * 60 * 60 * 1000;

  static generalConfig: GeneralConfig = new GeneralConfig();

  static bootControlsChecked: boolean; // Serve in mobile per capire se ho già fatto tutti i controlli all'avvio

  public fleetSelectedInStorage: Fleet;
  public fleetList: Fleet[] | null = [];

  tickets: Ticket[] = [];

  deadlineTarget: DeadlineTarget[] = [];
  deadline: Deadline[] = [];

  static firebase_storage: any;
  static pollingLoggedInInterval: any; // interval che verifica la sessione di login



  constructor(
    private storage: Storage,
    private alertPopupService: AlertPopupService,
    private modalCtrl: ModalController
  ) {
    console.log('[DataService] constructor OK');
  }

  async initialize(api: ApiService, firebase: any){
    console.log('[DataService] initialize() START');
    DataService.api = api;
    DataService.firebase = firebase;
    DataService.firebase_storage = firebase.storage().ref();

    // Propaga la baseUrl all'AlertPopupService (iniettato direttamente nel
    // costruttore: nessuna dipendenza circolare, vedi grafo dei servizi).
    this.alertPopupService.setBaseUrl(api.baseUrl);

    let dataLogin: any = await DataService.api.getLogin();

    if(dataLogin.token) {
      AuthService.token = dataLogin.token;
      if(AuthService.token?._id) await this.storage.set('authToken', AuthService.token._id.toString());
    }
    if(dataLogin.list_organization){
      this.organizations = [];
      for(let org of dataLogin.list_organization){
        this.organizations.push(new Organization(org));
      }
      if(dataLogin.list_partecipant && this.organizations.length > 0){
        this.selOrganization = this.organizations[0];
        DataService.idOrganization = this.selOrganization._id;
        this.triggerNotificationsDatabase(this.selOrganization._id);

        for(let part of dataLogin.list_partecipant){
          const org: Organization = this.organizations.find(el => el._id === part.idOrganization);
          let participant: Partecipant = new Partecipant(part);
          if(participant.email === AuthService.getEmail()){
            org.me = participant;
          }
          if(participant.isOwner){
            org.owner = participant;
          }
        }

        // Propaga l'idPartecipant all'AlertPopupService per costruire l'URL
        // delle chiamate di tracking (impression/dismiss/cta_click/cta_submit).
        this.alertPopupService.setIdPartecipant(this.selOrganization.me._id);

        try{
          let fleetList: any = await DataService.api.getFleet(this.selOrganization.me._id, this.selOrganization._id)
          if(fleetList && fleetList.fleets){
            for(let fleet of fleetList.fleets){
              this.fleetList.push(new Fleet(fleet))
            }
          }

          if(AuthService.fleet && this.fleetList){
            const new_fleet = this.fleetList.find(elem => elem._id === AuthService.fleet);
            if(new_fleet){
              await this.storage.set('fleet', new_fleet)
            }
          }

          this.fleetSelectedInStorage = await this.storage.get('fleet')

        }catch (e){
          console.log('Error in fleet management')
        }


        for(let part of dataLogin.list_partecipant){
          const org: Organization = this.organizations.find(el => el._id === part.idOrganization);
          let participant: Partecipant = new Partecipant(part)
          try{
            if(this.fleetSelectedInStorage){
              if(this.fleetSelectedInStorage.participants){
                for(let elem of this.fleetSelectedInStorage.participants){
                  if(elem.toString() === participant._id.toString()){
                    participant.$fleetShow = true;
                    break;
                  }else{
                    participant.$fleetShow = false;
                  }
                }
              }else{
                //se non è presente una flotta seleziona vuol dire che voglio vedere tutti i veicoli
                participant.$fleetShow = true;
              }
            }else{
              //se non è presente una flotta seleziona vuol dire che voglio vedere tutti i veicoli
              participant.$fleetShow = true;
            }
          }catch(err){
            participant.$fleetShow = true;
          }
          org.addParticipant(participant);
        }
      }
    }

    if(AuthService.token?._id) await this.storage.set('authToken', AuthService.token._id.toString());

    this.startPollingSessioneLoggedIn();


    /** Ottengo la lista di ticket in modo */
    try{
      let tickets: any = await DataService.api.getTicketsCommunication();
      if(tickets){
        for(let ticket of tickets){
          this.tickets.push(new Ticket(ticket))
        }
      }
    }catch(e){
      console.error('Error in getting user ticket')
    }


    /** Ottengo la lista di veicoli e autisti **/
    try{
      let deadline_target: any = await DataService.api.getDeadlinesTarget(this.selOrganization.me._id)
      if(deadline_target){
        for(let target of deadline_target){
          this.deadlineTarget.push(new DeadlineTarget(target))
        }
      }
    }catch (err){
      console.error('Error in get target', err)
    }

    this.initializeDemo();
    if(this.selOrganization.me.functionalityIsEnabled('poi')){
      await this.retrievePoi(api, 0).then(async () => {
        await this.retrieveAlarmsPoi(api, 0);
        DataService.initialized = true;
        DataService.onInit.next(true);
        this.checkAndShowAlertPopup();
      }).catch((err: any) => {
        console.error(err);
      });
    }else{
      DataService.initialized = true;
      DataService.onInit.next(true);
      this.checkAndShowAlertPopup();
    }
    this.retrieveNotificationCount();
    this.retriveTicketCount();
  }

  async startPollingSessioneLoggedIn(){
    try{
      console.log('inizio metodo start pooling')
      ApiService.pollingId = await this.storage.get('pollingId');
      if(!ApiService.pollingId){
        ApiService.pollingId = Utility.generateRandomKey(16);
        console.log('inizio metodo start pooling', ApiService.pollingId)
        await this.storage.set('pollingId', ApiService.pollingId);
      }
      if(DataService.pollingLoggedInInterval) clearInterval(DataService.pollingLoggedInInterval);
      const pollingFn = async () => {
        console.log('controllo polling per sessione loggata');
        await DataService.api.getPingUtente(this.selOrganization.me._id)
      };

      pollingFn(); // Chiamata immediata la prima volta
      DataService.pollingLoggedInInterval = setInterval(pollingFn, DataService.generalConfig?.pooling_sessione_login?.interval || 120000);

    }catch(err){
      console.error("Errore in avvio pooling sessione", err);
    }

  }

  async clearData(){
    this.pois = [];
    this.selOrganization = undefined;
    DataService.idOrganization = undefined;
    DataService.initialized = false;
    this.organizations = []
    this.tickets = [];
    this.resetDemo();
    if(DataService.pollingLoggedInInterval) clearInterval(DataService.pollingLoggedInInterval);
    if(this.notificationReference) this.notificationReference.off();
    ViewService.updateView.next(undefined);
  }

  /**
   * Costruisce l'organization finta della demo pubblica e la rende operativa.
   * Prende il posto di initialize(), che invece parte dal login reale: qui non
   * c'è né token né organization sul server, quindi nessuna chiamata di rete.
   *
   * Restano volutamente fuori, perché richiedono un utente autenticato:
   * getLogin, getFleet, triggerNotificationsDatabase (realtime firebase),
   * alertPopupService.setIdPartecipant, ticket e scadenze.
   *
   * `login_view_demo: true` sull'organization serve a riusare initializeDemo()
   * così com'è per generare i 3 veicoli finti, senza duplicarne la logica.
   */
  initializeDemoOrganization(){

    // Permessi: solo la superficie della demo (mappa, veicoli, storico).
    // NB: il campo raw è `functionality_veichle`, con il typo — vedi setData
    // di Partecipant. Usando il nome corretto il permesso resterebbe undefined.
    const me: Partecipant = new Partecipant({
      _id: 'demo-me',
      type: 1,
      idOrganization: 'demo',
      email: 'demo@demo',
      isOwner: true,
      isActive: true,
      functionality_veichle: true,
      functionality_map: true,
      functionality_historical: true,
      functionality_poi: true
    });

    const organization: Organization = new Organization({
      _id: 'demo',
      name: 'Demo',
      platform_type: ApiService.platformType,
      timezone: 'Europe/Rome',
      translate_language: 'it',
      timestamp_created: Date.now(),
      login_view_demo: true
    });
    organization.me = me;

    this.organizations = [organization];
    this.selOrganization = organization;
    DataService.idOrganization = organization._id;

    this.initializeDemo();

    // P.O.I. della demo: dati locali, nessuna chiamata a retrievePoi()
    this.pois = DEMO_POIS.map((raw: any) => new Poi(raw));

    // Sblocca le 77 pagine che aspettano DataService.isInitialized()
    DataService.initialized = true;
    DataService.onInit.next(true);
  }

  // Inizializza 3 veicoli demo
  initializeDemo(){
    if(this.selOrganization.login_view_demo){
      const intervalDelta: number = 3000;
      let positionCounter1: number = 0;
      let positionCounter2: number = 0;
      let positionCounter3: number = 0;
      this.selOrganization.participants = [];
      let firstPos: any = DEMO_ROUTES_LIVE['-1'][0];
      this.selOrganization.participants.push(new Partecipant({
        _id: '-1',
        isDemo: true,
        type: 2,
        idOrganization: this.selOrganization._id,
        type_trackerGps: 1,
        imei: '00000001',
        isActive: true,
        timestampActivation: 1605017515,
        label_number: 1,
        label_string: 'Veicolo demo 1',
        total_odometer: 1000,
        image: './assets/img/markers-demo/test-macchina.jpeg',
        fleetShow: true
      }));
      this.selOrganization.participants[0].resetDemoPosition(firstPos);
      this.intervalsDemo.push(setInterval(() => {
        setTimeout(() => {
          let pos: any = DEMO_ROUTES_LIVE['-1'][positionCounter1];
          if(!this.selOrganization.participants[0] || !this.selOrganization.participants[0].isDemo) return;
          this.selOrganization.participants[0].resetDemoPosition(pos);
          DataService.updateData.next({target: 'participant', type: 'update', participant: this.selOrganization.participants[0]});
          ViewService.updateView.next(undefined);
        }, Math.floor(Math.random() * (1000 - 1 + 1) + 1));
        positionCounter1++;
        if(positionCounter1 >= DEMO_ROUTES_LIVE['-1'].length) positionCounter1 = 0;
      }, intervalDelta));
      firstPos = DEMO_ROUTES_LIVE['-2'][0];
      this.selOrganization.participants.push(new Partecipant({
        _id: '-2',
        isDemo: true,
        type: 2,
        idOrganization: this.selOrganization._id,
        type_trackerGps: 1,
        imei: '00000002',
        isActive: true,
        timestampActivation: 1605017515,
        label_number: 2,
        label_string: 'Veicolo demo 2',
        total_odometer: 1000,
        image: './assets/img/markers-demo/test-furgone.jpeg',
        fleetShow: true
      }));
      this.selOrganization.participants[1].resetDemoPosition(firstPos);
      this.intervalsDemo.push(setInterval(() => {
        setTimeout(() => {
          let pos: any = DEMO_ROUTES_LIVE['-2'][positionCounter2];
          if(!this.selOrganization.participants[1] || !this.selOrganization.participants[1].isDemo) return;
          this.selOrganization.participants[1].resetDemoPosition(pos);
          DataService.updateData.next({target: 'participant', type: 'update', participant: this.selOrganization.participants[1]});
          ViewService.updateView.next(undefined);
        }, Math.floor(Math.random() * (1000 - 1 + 1) + 1));
        positionCounter2++;
        if(positionCounter2 >= DEMO_ROUTES_LIVE['-2'].length) positionCounter2 = 0;
      }, intervalDelta));
      firstPos = DEMO_ROUTES_LIVE['-3'][0];
      this.selOrganization.participants.push(new Partecipant({
        _id: '-3',
        isDemo: true,
        type: 2,
        idOrganization: this.selOrganization._id,
        type_trackerGps: 1,
        imei: '00000003',
        isActive: true,
        timestampActivation: 1605017515,
        label_number: 3,
        label_string: 'Veicolo demo 3',
        total_odometer: 1000,
        image: './assets/img/markers-demo/test-tir.jpeg',
        fleetShow: true
      }));
      this.selOrganization.participants[2].resetDemoPosition(firstPos);
      this.intervalsDemo.push(setInterval(() => {
        setTimeout(() => {
          let pos: any = DEMO_ROUTES_LIVE['-3'][positionCounter3];
          if(!this.selOrganization.participants[2] || !this.selOrganization.participants[2].isDemo) return;
          this.selOrganization.participants[2].resetDemoPosition(pos);
          DataService.updateData.next({target: 'participant', type: 'update', participant: this.selOrganization.participants[2]});
          ViewService.updateView.next(undefined);
        }, Math.floor(Math.random() * (1000 - 1 + 1) + 1));
        positionCounter3++;
        if(positionCounter3 >= DEMO_ROUTES_LIVE['-3'].length) positionCounter3 = 0;
      }, intervalDelta));
      this.isDemo = true;
    }
  }

  // Resetta tutte le impostazioni demo
  resetDemo(): boolean{
    for(let interval of this.intervalsDemo){
      clearInterval(interval);
    }
    this.isDemo = false;
    this.intervalsDemo = [];
    if(this.selOrganization && this.selOrganization.participants){
      for(let i=0; i<this.selOrganization.participants.length; i++){
        if(this.selOrganization.participants[i].isDemo){
          DataService.updateData.next({target: 'participant', type: 'delete', participant: this.selOrganization.participants[i]});
          this.selOrganization.participants.splice(i, 1);
          i--;
        }
      }
    }
    return false;
  }

  getMeId(){
    if(this.selOrganization && this.selOrganization.me) return this.selOrganization.me._id;
  }

  // recupera i poi
  retrievePoi(api: ApiService, skip: number){
    return new Promise((resolve, reject) => {
      if(skip === 0) this.pois = [];
      api.getPois(this.selOrganization.me._id, skip, DataService.limit).then( async(res: any) => {
        if(res.data){
          for(let raw of res.data){
            this.pois.push(new Poi(raw));
          }
        }
        if(!res.has_more){
          ViewService.updateView.next(undefined);
          return resolve(null)
        }else{
          return resolve(this.retrievePoi(api, skip + res.data.length));
        }
      }).catch((err: any) => {
        return reject(err);
      })
    })
  }

  // recupera gli allarmi e gli associa ai poi
  retrieveAlarmsPoi(api: ApiService, skip: number){
    return new Promise((resolve, reject) => {
      api.getAlarmsPoi(this.selOrganization.me._id, skip, DataService.limit).then(async (res: any) => {
        if(res.data){
          for(let raw of res.data){
            const alarm: AlarmPoi = new AlarmPoi(raw);
            alarm.poi = this.pois.find((elem: Poi) => {
              return elem._id === alarm.idPoi;
            });
            const participant: Partecipant = this.selOrganization.participants.find((elem: Partecipant) => {
              return elem._id === alarm.idPartecipant;
            });
            if(participant){
              participant.addAlarmPoi(alarm);
            }
          }
        }
        if(!res.has_more){
          ViewService.updateView.next(undefined);
          return resolve(null)
        }else{
          return resolve(this.retrievePoi(api, skip + res.data.length));
        }
      }).catch((err: any) => {
        return reject(err);
      })
    })
  }

  retrieveNotificationCount(){
    DataService.api.getNotificationsCount(this.selOrganization.me._id).then((res: any) => {
      if(res){
        this.notificationsCount = res.data;
        ViewService.updateView.next(undefined);
      }
    }).catch((err: any) => {
      console.error(err);
    });
  }

  retriveTicketCount(){
    DataService.api.getTicketCount().then((res: any) => {
      if(res){
        this.ticketCount = res.data;
        ViewService.updateView.next(undefined);
      }
    }).catch((err: any) => {
      console.error(err);
    });
  }

  retriveDeadline(skip: number){
    return new Promise((resolve, reject) => {
      this.deadline = [];
      DataService.api.getDeadlines(skip, DataService.limit, this.selOrganization.me._id).then(async (res: any) => {
        if(res){
          for(let raw of res){
            this.deadline.push(new Deadline(raw, {getParticipant: this.selOrganization.getParticipant.bind(this.selOrganization), getTarget: this.getTarget.bind(this)}))
          }
        }
        return resolve(null)

      }).catch((err: any) => {
        return reject(err);
      })
    })
  }

  static isInitialized(){
    return new Promise((resolve) => {
      if(DataService.initialized) return resolve(null)
      let listener: any = DataService.onInit$.subscribe(() => {
        listener.unsubscribe();
        return resolve(null)
      });
    });
  }
  static isGeneralConfig(){
    return new Promise((resolve) => {
      if(DataService.hasGeneralConfig) return resolve(null)
      let listener: any = DataService.onGeneralConfig$.subscribe(() => {
        listener.unsubscribe();
        return resolve(null)
      });
    });
  }


  notificationReference: any;

  private triggerNotificationsDatabase(organizationId: string){
    if(this.notificationReference) this.notificationReference.off();

    this.notificationReference = DataService.firebase.database().ref('/organization/' + organizationId);
    let first: boolean = true;
    this.notificationReference.on('value', (snapshot: any) => {
      if(!first){
        this.parseNotification(snapshot.val());
      }else{
        first = false;
      }
    });
  }

  /**
   * Parsifica l'oggetto di notifica ricevuto sul database delle notifiche
   * @param notification
   */
  private parseNotification(notification: any){
    if(!notification) return;
    switch (notification.element){
      case 'organization':
        this.manageOrganizationNotification(notification);
        break;
      case 'partecipant':
        this.manageParticipantNotification(notification);
        break;
      case 'poi':
        this.managePoiNotification(notification);
        break;
      case 'list_commandTrackerGps_finished':
        DataService.updateData.next({target: 'commandTrackerGps', type: notification.type, id: notification._id});
        break;
      case 'notification':
        this.retrieveNotificationCount();
        DataService.updateData.next({target: 'notification', type: notification.type, id: notification._id});
        break;
      case 'ticket':
        this.retriveTicketCount();
        DataService.updateData.next({target: 'ticket', type: notification.type, id: notification._id});
        break;
      case 'force_refresh':
        if(!DataService.nativeApp){
          console.log('Arrivato un force refresh da remoto');
          location.reload();
        }
        break;
      case 'batch_report':
        DataService.updateData.next({target: 'batch_report', type: notification.type, id: notification._id, id_participant: notification.id_participant});
        break;
      case 'condivisione_posizione':
        DataService.updateData.next({target: 'condivisione_posizione', type: notification.type, id: notification._id});
        break;
      case 'percorso':
        DataService.updateData.next({
          target: 'percorso',
          type: notification.type,
          id: notification._id,
          update_scope: notification.update_scope
        });
        break;
      case 'linea':
        DataService.updateData.next({
          target: 'linea',
          type: notification.type,
          id: notification._id,
          changed_percorso_id: !!notification.changed_percorso_id
        });
        break;
      case 'corsa_template':
        DataService.updateData.next({
          target: 'corsa_template',
          type: notification.type,
          id: notification._id
        });
        break;
      case 'corsa':
        DataService.updateData.next({
          target: 'corsa',
          type: notification.type,
          id: notification._id
        });
        break;
      case 'share_link':
        DataService.updateData.next({
          target: 'share_link',
          type: notification.type,
          id: notification._id
        });
        break;
      case 'alert':
        DataService.updateData.next({
          target: 'alert',
          type: notification.type,
          id: notification._id
        });
        this.checkAndShowAlertPopup();
        break;
    }
  }

  async checkAndShowAlertPopup() {
    // ================================================================
    // GUARDIA DESKTOP-ONLY — NON RIMUOVERE
    // Gli avvisi/popup devono essere mostrati SOLO sulla versione desktop
    // dell'app. In mobile (sia web che nativo Capacitor) non devono MAI
    // apparire, per qualsiasi motivo. Se in futuro servissero anche su
    // mobile, va valutato un redesign del popup per mobile (spazio ridotto,
    // touch target, ecc.).
    // ================================================================
    if (ViewService.isMobile) {
      console.log('[AlertPopup] skipped - mobile platform (desktop-only feature)');
      return;
    }

    // Salta i popup avvisi quando l'utente è nel flusso free-trial (wizard).
    // Distrarrebbero il flusso di registrazione/checkout.
    try {
      const path = (typeof window !== 'undefined' && window.location?.pathname) || '';
      if (path.startsWith('/free-trial')) {
        console.log('[AlertPopup] skipped - pathname is', path);
        return;
      }
    } catch (e) {
      // ignore — proseguiamo coi controlli successivi
    }

    console.log('[AlertPopup] checkAndShowAlertPopup() called');
    try {
      console.log('[AlertPopup] fetching active alert...');
      const alertData = await this.alertPopupService.getActiveAlert();

      if (alertData && alertData.alert && alertData.alert._id) {
        const alert = alertData.alert;
        console.log('[AlertPopup] Active alert found:', alert._id, alert.title);

        // Lazy import to avoid circular dependency
        const { AlertPopupPage } = await import('../../components/common/alert-popup/alert-popup.page');

        const modal = await this.modalCtrl.create({
          component: AlertPopupPage,
          componentProps: {
            alert: alert,
            view: ViewService
          },
          backdropDismiss: false,
          cssClass: 'modal_alarm'
        });

        await modal.present();
        console.log('[AlertPopup] Modal presented');

        const result = await modal.onDidDismiss();
        if (result && result.data) {
          console.log('[AlertPopup] Modal dismissed with result:', result.data);
        }
      } else {
        console.log('[AlertPopup] No active alert found');
      }
    } catch (err) {
      console.error('[AlertPopup] Error checking/showing alert popup:', err);
    }
  }

  // Gestisce update di una organizzazione
  async manageOrganizationNotification(notification: any){
    switch (notification.type) {
      case 'update':
        console.log('UPDATE/CREATE organization');
        if(this.selOrganization._id === notification._id){
          await DataService.api.getOrganization(this.selOrganization.me._id, notification._id).then((res: any) => {
            this.selOrganization.setData(res);
            if(!this.selOrganization.login_view_demo) this.isDemo = this.resetDemo();
            DataService.updateData.next({target: 'organization', type: notification.type});
            ViewService.updateView.next(undefined);
          }).catch((err: any) => {
            console.error(err);
          });
        }
        break;
    }
  }

  // Gestisce update, cancellazione e inserimento di un partecipante

  static participant_updates: Map<string, boolean> = new Map<string, boolean>();
  static in_updating_participants: boolean;
  static last_update_participants: number = Date.now();
  static timeout_update_participants: any;
  static delta_update_participants: any = 2 * 1000;

  private async updateParticipants(){
    if(DataService.in_updating_participants){ // qualcuno ha già chiamato questo metodo e non vogliamo esecuzioni contemporanee
      // console.error('Non aggiorno participant perchè stanno già aggiornando');
      return;
    }
    DataService.in_updating_participants = true;
    try{
      if(DataService.last_update_participants > Date.now() - DataService.delta_update_participants){ // non aggiorniamo perchè è troppo presto;
        // console.error('Non aggiorno participant perchè troppo presto');
        if(!DataService.timeout_update_participants){
          // console.log('Avvio timeout prossimo update');
          DataService.timeout_update_participants = setTimeout(this.updateParticipants.bind(this), DataService.delta_update_participants);
        }
        DataService.in_updating_participants = false;
        return;
      }
      // console.log('Attivato update partecipant');
      if(DataService.timeout_update_participants){
        // console.log('Avevo timeout, lo pulisco');
        clearTimeout(DataService.timeout_update_participants);
        DataService.timeout_update_participants = undefined;
      }
      const to_update: string[] = [];
      for (const id of DataService.participant_updates.keys()) {
        DataService.participant_updates.delete(id); // lo toglie dalla lista di quelli da aggiornare;
        let participant: Partecipant;
        participant = this.selOrganization.participants.find((elem: Partecipant) => {
          return elem._id === id;
        });
        to_update.push(id);
        // await DataService.api.getParticipant(this.selOrganization.me._id, id).then((res: any) => {
        //   if(participant){
        //     participant.setData(res);
        //     DataService.updateData.next({target: 'participant', type: 'update', participant: participant});
        //     ViewService.updateView.next(undefined);
        //   }
        // }).catch((err: any) => {
        //   console.error(err);
        // });
      }
      const res: any = await DataService.api.getParticipantsBucket(this.selOrganization.me._id, to_update);
      for(const raw of res){
        const participant: Partecipant = this.selOrganization.participants.find((elem: Partecipant) => {
          return elem._id === raw._id;
        });
        if(participant){
          participant.setData(raw);
          if(participant.isQueclink() && !participant.isGPSOk()) await participant.requestGeolocation(DataService.api, this.selOrganization.me._id)
          DataService.updateData.next({target: 'participant', type: 'update', participant: participant});
        }
      }
      ViewService.updateView.next(undefined);
    }catch(err){
      console.error('Errore grave in updateParticipants');
    }
    // console.log('Finito update partecipant');
    DataService.in_updating_participants = false;
    DataService.last_update_participants = Date.now();
  }

  async manageParticipantNotification(notification: any){
    let participant: Partecipant;
    switch (notification.type) {
      case 'insert':
      case 'create':
        participant = this.selOrganization.participants.find((elem: Partecipant) => {
          return elem._id === notification._id;
        });
        await DataService.api.getParticipant(this.selOrganization.me._id, notification._id).then((res: any) => {
          if(participant){
            participant.setData(res);
            DataService.updateData.next({target: 'participant', type: 'update', participant: participant});
          }else{
            participant = new Partecipant(res);
            if(this.fleetSelectedInStorage){
              //se ho una flotta selezionata non voglio visualizzare il nuovo participant
              participant.$fleetShow = false;
            }
            this.selOrganization.addParticipant(participant);
            DataService.updateData.next({target: 'participant', type: 'create', participant: participant});
          }
          ViewService.updateView.next(undefined);
        }).catch((err: any) => {
          console.error(err);
        });
        break;
      case 'update':
        if(notification.isPosition){ // le posizioni le gestiamo per non fare troppi update contemporaneamente
          DataService.participant_updates.set(notification._id, true);
          this.updateParticipants();
        }else{ // tutti gli altri update di participant invece faccio la solita gestione
          participant = this.selOrganization.participants.find((elem: Partecipant) => {
            return elem._id === notification._id;
          });
          await DataService.api.getParticipant(this.selOrganization.me._id, notification._id).then(async (res: any) => {
            if(participant){
              participant.setData(res);
              if(participant.isQueclink() && !participant.isGPSOk()) await participant.requestGeolocation(DataService.api, this.selOrganization.me._id)
              DataService.updateData.next({target: 'participant', type: 'update', participant: participant});
              ViewService.updateView.next(undefined);
            }
          }).catch((err: any) => {
            console.error(err);
          });
        }
        break;
      case 'delete':
        this.selOrganization.removeParticipant(notification._id);
        DataService.updateData.next({target: 'participant', type: notification.type, id: notification._id});
        ViewService.updateView.next(undefined);
        break;
    }
  }

  // Gestisce update, cancellazione e inserimento di un poi
  private managePoiNotification(notification: any){
    switch (notification.type) {
      case 'create':
      case 'update':
        DataService.api.getPoi(this.selOrganization.me._id, notification._id).then((res: any) => {
          /* IMPORTANTE: la find() va fatta DOPO che getPoi resolve, NON prima.
           * Se due notifiche arrivano ravvicinate (es. POST 'create' + PATCH 'update'
           * dallo stesso submit), entrambe avrebbero catturato poi=undefined nella
           * closure prima che la prima riuscisse a pusharlo, e l'array finirebbe
           * con due copie dello stesso POI. */
          let poi: Poi = this.pois.find((elem: Poi) => {
            return elem._id === notification._id;
          });
          if(poi){
            poi.setData(res);
          }else{
            poi = new Poi(res);
            this.pois = [...this.pois, poi]
          }
          DataService.updateData.next({target: 'poi', poi: poi});
          ViewService.updateView.next(undefined);
        }).catch((err: any) => {
          console.error(err);
        });
        break;
      case 'delete':
        for(let i=0; i<this.pois.length; i++){
          if(this.pois[i]._id === notification._id){
            this.pois.splice(i, 1);
            this.pois = [...this.pois]
            break;
          }
        }
        DataService.updateData.next({target: 'poi', type: notification.type, id: notification._id});
        ViewService.updateView.next(undefined);
        break;
    }
  }

  /* ── P.O.I. in demo pubblica ───────────────────────────────────────────────
   * Create/update/delete senza API: replicano in locale gli stessi effetti che
   * managePoiNotification produce quando arriva la notifica firebase.
   * Come per saveDemoAlarm le modifiche vivono solo in memoria: al refresh la
   * demo riparte dai dati di DEMO_POIS. */

  /** Serializza un Poi nella forma raw attesa da Poi.setData(). */
  private poiToRaw(poi: Poi): any {
    return {
      _id: poi._id,
      name: poi.name,
      idOrganization: poi.idOrganization,
      images: poi.images,
      position: poi.position,
      radius: poi.radius,
      area_type: poi.area_type,
      area: poi.area,
      color: poi.color,
      timestampCreate: poi.timestampCreate,
      timestampLastUpdate: poi.timestampLastUpdate,
      address: poi.address,
      label_number: poi.label_number,
      image: poi.image,
      codice_cliente: poi.codice_cliente,
      note: poi.note,
      giorni_consegna: poi.giorni_consegna,
      orari_consegna: poi.orari_consegna
    };
  }

  /** Modifica un P.O.I. demo: merge dei campi passati e ritorna il raw aggiornato. */
  updateDemoPoi(idPoi: string, fields: any): any {
    const poi: Poi = this.pois.find((elem: Poi) => elem._id === idPoi);
    if(!poi) return null;
    const raw: any = Object.assign(this.poiToRaw(poi), fields);
    raw.timestampLastUpdate = Math.floor(Date.now() / 1000);
    poi.setData(raw);
    this.pois = [...this.pois];
    DataService.updateData.next({target: 'poi', poi: poi});
    ViewService.updateView.next(undefined);
    return raw;
  }

  /** Crea un P.O.I. demo e lo aggiunge alla lista. Ritorna il raw creato. */
  createDemoPoi(fields: any): any {
    const now: number = Math.floor(Date.now() / 1000);
    const raw: any = Object.assign({
      _id: this.generateDemoId(),
      idOrganization: DataService.idOrganization,
      timestampCreate: now,
      timestampLastUpdate: now,
      codice_cliente: '',
      note: '',
      giorni_consegna: [],
      orari_consegna: []
    }, fields);
    const poi: Poi = new Poi(raw);
    this.pois = [...this.pois, poi];
    DataService.updateData.next({target: 'poi', poi: poi});
    ViewService.updateView.next(undefined);
    return raw;
  }

  /** Elimina un P.O.I. demo dalla lista. */
  deleteDemoPoi(idPoi: string){
    for(let i=0; i<this.pois.length; i++){
      if(this.pois[i]._id === idPoi){
        this.pois.splice(i, 1);
        this.pois = [...this.pois];
        break;
      }
    }
    DataService.updateData.next({target: 'poi', type: 'delete', id: idPoi});
    ViewService.updateView.next(undefined);
  }

  /** Id in stile ObjectId (24 hex) per gli elementi creati in demo. */
  private generateDemoId(): string {
    let id: string = Math.floor(Date.now() / 1000).toString(16);
    while(id.length < 24) id += Math.floor(Math.random() * 16).toString(16);
    return id.substring(0, 24);
  }

  // Ritorna un report per un veicolo demo
  getDemoReport(participant: Partecipant, start: number, stop: number){
    if(!participant.isDemo) return [];
    let res: any = {
      data: [],
      report: {
        time_total: 60 * 60 * 1000,
        time_trip: 30 * 60 * 1000,
        total_distance: 10000,
        time_stop: 30 * 60 * 1000
      }
    };

    let totalPositions: any[] = DEMO_ROUTES['-1'];
    if(DEMO_ROUTES[participant._id]){
      totalPositions = DEMO_ROUTES[participant._id];
    }

    for(let pos of totalPositions){
      let raw: any = {
        _id: pos._id.toString(),
        idOrganization: participant.idOrganization,
        type: 2,
        position: {
          type: 'Point',
          coordinates: [pos.longitude, pos.latitude]
        },
        imei: participant.imei,
        timestamp_server: pos.delta_ms + start,
        timestamp_position: pos.delta_ms + start,
        position_type: 5,
        altitude: 0,
        angle: pos.angle || 0,
        satellites: 3,
        speed: pos.speed,
        total_odometer: pos.total_odometer,
        avl_id: 250,
        value: pos.position_type === 'moving' ? 1 : 0
      };
      if((res.data.length === 0 || res.data[res.data.length - 1].value !== raw.value)
        && (pos.delta_ms + start) <= stop){
        res.data.push(raw);
      }
    }
    if(res.data.length > 0){
      res.data.push({
        _id: 'end',
        idOrganization: participant.idOrganization,
        type: 2,
        position: {
          type: 'Point',
          coordinates: [res.data[res.data.length - 1].longitude, res.data[res.data.length - 1].latitude]
        },
        imei: participant.imei,
        timestamp_server: stop,
        timestamp_position: stop,
        position_type: 5,
        altitude: 0,
        angle: res.data[res.data.length - 1].angle || 0,
        satellites: 3,
        speed: res.data[res.data.length - 1].speed,
        total_odometer: res.data[res.data.length - 1].total_odometer,
        avl_id: 250,
        value: res.data[res.data.length - 1].value === 1 ? 0 : 1
      });
    }
    return res;
  }

  // Ritorna un report per un veicolo demo
  getDemoHistory(participant: Partecipant, start: number, stop: number){
    if(!participant.isDemo) return [];
    let totalPositions: any[] = DEMO_ROUTES['-1'];
    if(DEMO_ROUTES[participant._id]){
      totalPositions = DEMO_ROUTES[participant._id];
    }    let res: any = {data: [], has_more: false};
    for(let pos of totalPositions){
      let raw: any = {
        _id: pos._id.toString(),
        idOrganization: participant.idOrganization,
        type: 2,
        position: {
          type: 'Point',
          coordinates: [pos.longitude, pos.latitude]
        },
        imei: participant.imei,
        timestamp_server: pos.delta_ms + start,
        timestamp_position: pos.delta_ms + start,
        position_type: 4,
        altitude: 0,
        angle: pos.angle || 0,
        satellites: 3,
        speed: pos.speed,
        total_odometer: pos.total_odometer
      };
      res.data.push(raw);
    }
    return res;
  }

  // Salva un allarme su un veicolo demo
  saveDemoAlarm(type: string, target: Partecipant, values: Partecipant){
    switch (type) {
      case 'speed':
        target.speed_alarm_enable = values.speed_alarm_enable;
        target.speed_alarm_value = values.speed_alarm_value;
        target.speed_alarm_hour_start = values.speed_alarm_hour_start;
        target.speed_alarm_minute_start = values.speed_alarm_minute_start;
        target.speed_alarm_hour_stop = values.speed_alarm_hour_stop;
        target.speed_alarm_minute_stop = values.speed_alarm_minute_stop;
        target.speed_alarm_day = values.speed_alarm_day;
        target.speed_alarm_email = values.speed_alarm_email;
        target.speed_alarm_partecipant = values.speed_alarm_partecipant;
        break;
      case 'offline':
        target.offline_alarm_enable = values.offline_alarm_enable;
        target.offline_alarm_value = values.offline_alarm_value;
        target.offline_alarm_hour_start = values.offline_alarm_hour_start;
        target.offline_alarm_minute_start = values.offline_alarm_minute_start;
        target.offline_alarm_hour_stop = values.offline_alarm_hour_stop;
        target.offline_alarm_minute_stop = values.offline_alarm_minute_stop;
        target.offline_alarm_day = values.offline_alarm_day;
        target.offline_alarm_email = values.offline_alarm_email;
        target.offline_alarm_partecipant = values.offline_alarm_partecipant;
        break;
      case 'movement':
        target.movement_alarm_enable = values.movement_alarm_enable;
        target.movement_alarm_hour_start = values.movement_alarm_hour_start;
        target.movement_alarm_minute_start = values.movement_alarm_minute_start;
        target.movement_alarm_hour_stop = values.movement_alarm_hour_stop;
        target.movement_alarm_minute_stop = values.movement_alarm_minute_stop;
        target.movement_alarm_day = values.movement_alarm_day;
        target.movement_alarm_email = values.movement_alarm_email;
        target.movement_alarm_partecipant = values.movement_alarm_partecipant;
        break;
      case 'unplug':
        target.unplug_alarm_enable = values.unplug_alarm_enable;
        target.unplug_alarm_hour_start = values.unplug_alarm_hour_start;
        target.unplug_alarm_minute_start = values.unplug_alarm_minute_start;
        target.unplug_alarm_hour_stop = values.unplug_alarm_hour_stop;
        target.unplug_alarm_minute_stop = values.unplug_alarm_minute_stop;
        target.unplug_alarm_day = values.unplug_alarm_day;
        target.unplug_alarm_email = values.unplug_alarm_email;
        target.unplug_alarm_partecipant = values.unplug_alarm_partecipant;
        break;
      case 'parking':
        target.parking_alarm_enable = values.parking_alarm_enable;
        target.parking_alarm_hour_start = values.parking_alarm_hour_start;
        target.parking_alarm_minute_start = values.parking_alarm_minute_start;
        target.parking_alarm_hour_stop = values.parking_alarm_hour_stop;
        target.parking_alarm_minute_stop = values.parking_alarm_minute_stop;
        target.parking_alarm_day = values.parking_alarm_day;
        target.parking_alarm_email = values.parking_alarm_email;
        target.parking_alarm_partecipant = values.parking_alarm_partecipant;
        break;
      case 'input1':
        target.din1_alarm_enable = values.din1_alarm_enable;
        target.din1_alarm_value = values. din1_alarm_value;
        target.din1_alarm_hour_start = values.din1_alarm_hour_start;
        target.din1_alarm_minute_start = values.din1_alarm_minute_start;
        target.din1_alarm_hour_stop = values.din1_alarm_hour_stop;
        target.din1_alarm_minute_stop = values.din1_alarm_minute_stop;
        target.din1_alarm_day = values.din1_alarm_day;
        target.din1_alarm_email = values.din1_alarm_email;
        target.din1_alarm_partecipant = values.din1_alarm_partecipant;
        break;
    }
  }

  // Salva i dati di un veicolo demo in maniera fittizia
  saveDemoFields(target: Partecipant, name: string, label_number: number, odometer: number, image?: string, chassis_number?: string){
    target.name = name;
    target.label_number = label_number;
    target.total_odometer = odometer;
    /* Stessa convenzione del ramo non-demo (vedi car-fields.page): undefined
     * significa "non toccare", null "rimuovi". Assegnare sempre cancellava
     * l'immagine quando si modificava solo il nome. */
    if(image !== undefined) target.image = image || undefined;
    if(chassis_number !== undefined) target.chassis_number = chassis_number;
    DataService.updateData.next({target: 'participant', type: 'update', participant: target});
  }

  getPoi(id: string){
    return this.pois.find((elem: Poi) => {
      return elem._id === id;
    });
  }

  static clearActivationParams(){
    DataService.activationImei = undefined;
    DataService.activationSerial = undefined;
    DataService.activationModel = undefined;
    DataService.registrationEmail = undefined;
    AuthService.redirect = undefined
    AuthService.openModal = false;
  }

  // Invia un log ai server se avviene un errore in lancio di una pagina che non è gestito in altro modo
  static async manageStartupPageError(page: string, message: string, error: any){
    try{
      console.error(message || 'manageStartupPageError', error);
      await DataService.isInitialized();
      await DataService.api.sendLog(2, page, message || undefined,error?.message || undefined, DataService.nativeApp, DataService.version, DataService.idOrganization);
    }catch(err){
      console.error('Impossibile inviare log di errore in startup di pagina', err);
    }
  }

  async uploadMedia(name: string, file: any, metadata?: any){
    if(name && file){
      try{
        const url: string = `temp/${Date.now()}_${Math.floor(Math.random() * 10000) + 1}/${name}`
        const ref: any = DataService.firebase_storage.child(url);
        await ref.put(file, metadata);
        return url;
      }catch(err){
        console.error(err);
        return undefined
      }
    }
  }

  async getMediaInfo(name: string): Promise<{url: string, metadata: any}>{
    if(name){
      try{
        const ref: any = DataService.firebase_storage.child(name);
        let results: any[] = await Promise.all([
          ref.getDownloadURL(),
          ref.getMetadata()
        ]);
        let result: any = {
          url: results[0],
          metadata: results[1]
        };
        ViewService.updateView.next(undefined);
        return result;
      }catch(err){
        console.error(err);
        return undefined
      }
    }
  }


  getTicket(id: string){
    return this.tickets.find((ticket: Ticket) => {
      return ticket._id === id;
    });
  }

  findParticipantByImei(imei: string){
    return this.selOrganization.participants?.find((elem)=>elem.imei === imei)
  }

  getTarget(id: string): DeadlineTarget{
    return this.deadlineTarget.find(elem => elem._id === id)
  }

  // Controlla in general_parameter se quel ipo di tracker nella nostra piattaforma ha l'ingresso disponibile
  trackerGpsHaveDin1(typeTracker: number){
    const info_tracker: TypeParticipant = DataService.generalConfig.$map_type_participant_trackers.get(typeTracker);
    return info_tracker?.din1_avaible;
  }

  trackerGpsHaveDout1(typeTracker: number){
    const info_tracker: TypeParticipant = DataService.generalConfig.$map_type_participant_trackers.get(typeTracker);
    return info_tracker?.dout1_avaible;
  }

  getProgrammingVersion(version: number){
    return DataService.generalConfig.queclink_configuration_files.find(elem => elem.version === version);
  }

  getProgrammingVersionForTypeSim(type_sim: number){
    return DataService.generalConfig.queclink_configuration_files.filter(elem => elem.type_sim === type_sim);
  }

  /** Apre l'App Store / Play Store per l'aggiornamento dell'app usando gli URL
   *  configurati in general_parameter (sito.io_store.app_store / play_store).
   *  Fallback su URL generici degli store se la config non è disponibile. */
  static openAppStoreForUpdate(): void {
    const io_store = DataService.generalConfig?.sito?.io_store;
    let url: string;
    if(DataService.nativeApp === 'ios'){
      url = io_store?.app_store || "https://www.apple.com/it/ios/app-store/";
    }else{
      url = io_store?.play_store || "https://play.google.com/";
    }
    AppLauncher.openUrl({url});
  }

  /** True se la pagina nativa NON è abilitata per la versione corrente dell'app
   *  (versione < min_version configurata per la pagina/piattaforma in general_parameter).
   *  Ritorna false se non siamo in nativo, se manca la config o se la versione è ok. */
  static shouldOpenPageInWebFallback(pageKey: string): boolean {
    if(!DataService.nativeApp) return false;
    const platformConfig = DataService.generalConfig?.native_pages_min_version?.[DataService.nativeApp];
    const minForPage = platformConfig?.[pageKey];
    if(!minForPage) return false;
    const currentVersion = Utility.parseVersionNumber(DataService.version);
    const minVersion = Utility.parseVersionNumber(minForPage);
    return currentVersion < minVersion;
  }
}
